import React from "react";
import { Product } from "../types";
import { ProductCard } from "./ProductCard";

type Props = {
  products: Product[];
  onAddToCart: (p: Product) => void;
  onViewDetails: (p: Product) => void;
};

const gridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
  gap: 12,
};

export const ProductGrid: React.FC<Props> = ({
  products,
  onAddToCart,
  onViewDetails,
}) => {
  return (
    <div style={gridStyle} className="product-grid">
      {products.map((p) => (
        <ProductCard
          key={p.id}
          product={p}
          onAddToCart={onAddToCart}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
};
